export default __webpack_public_path__ + "static/media/reserve-banner.57f8a004.png";